const LoadingConstants = {
    SET_LOADING: 'SET_LOADING',
    DISABLE_LOADING: 'DISABLE_LOADING',
  };
  
  export default LoadingConstants;